import Axios from 'axios';
import { PageableResponse } from '../models';
import { CommerceSubscription } from '../models/commerceSubscription';
import { composeQuery, Query } from '../models/query';

export const getSubscriptions = async (
  ...criteria: Query<CommerceSubscription>[]
) => (
  await Axios.get<PageableResponse<CommerceSubscription>>('/v1/commerce/subscriptions', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: {
      ...composeQuery<CommerceSubscription>(...criteria),
    },
    data: {},
  })).data;
